import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { BaseListWebService } from '@web/base/shared/components/base-list-web/base-list-web.service';
import { URL } from '../../../../environments/environment';

@Injectable()
export class ObservatoriesService extends BaseListWebService {

  constructor(public http: HttpClient) {
    super(http);
  }

  loadObservatory(observatoryID) {
    const url = `${URL}/observatories-menus/find`;
    return this.http.post(url, { observatoryID });
  }

}
